import React from 'react';
import { PriceAlert } from '../components/PriceAlert';
import { HeroLP1 } from '../components/HeroLP1';
import { Testimonial } from '../components/Testimonial';
import { ProblemSolution } from '../components/ProblemSolution';
import { ValueStack } from '../components/ValueStack';
import { ModuleBreakdown } from '../components/ModuleBreakdown';
import { Guarantee } from '../components/Guarantee';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPageLP1() {
  return <div className="w-full min-h-screen bg-navy font-body text-white" data-id="element-1122">
      <PriceAlert data-id="element-1123" />
      <HeroLP1 data-id="element-1124" />
      <Testimonial data-id="element-1125" />
      <ProblemSolution data-id="element-1126" />
      <ValueStack data-id="element-1127" />
      <ModuleBreakdown data-id="element-1128" />
      <Guarantee data-id="element-1129" />
      <PricingSection data-id="element-1130" />
      <Footer data-id="element-1131" />
      <RecentPurchaseToast data-id="element-1132" />
    </div>;
}